export default "__VITE_ASSET__C_bIc$un__"